import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { Header, MainSidebar, Content, Footer } from "..";
import { useNavigate } from "react-router-dom";
import { SessionModal } from "..";
import { useState } from "react";

function MainLayout() {
  const [sessionModalIsOpen, setOpenSessionModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    window.dispatchEvent(new Event("resize"));

    const interval = setInterval(() => {
      const currentSession = JSON.parse(sessionStorage.getItem("sessionDate"));
      const currentDate = new Date().toLocaleString();

      if (currentDate > currentSession) {
        setOpenSessionModal(true);
      }
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    window.dispatchEvent(new Event("resize"));

    const intervalForUser = setInterval(() => {
      const isUser = JSON.parse(localStorage.getItem("isUser"));

      if (!isUser) {
        navigate("/login");
      }
    }, 10000);

    return () => clearInterval(intervalForUser);
  }, []);

  return (
    <>
      <Header />
      <MainSidebar />
      <main>
        <Content>
          <Outlet />
        </Content>
      </main>
      <Footer />
      <SessionModal
        sessionModalIsOpen={sessionModalIsOpen}
        setOpenSessionModal={setOpenSessionModal}
      />
    </>
  );
}

export default MainLayout;
